import React, {createContext, useContext, useEffect, useState} from "react";
import {apiRequest} from "../utils/api";

const AuthContext = createContext(null);

const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshUser = async () => {
        try {
            const response = await apiRequest("auth/me.php", {method: "GET", headers: {}});
            setUser(response.user);
            return response.user;
        } catch (error) {
            setUser(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshUser();
    }, []);

    const login = async (loginValue, password) => {
        const response = await apiRequest("auth/login.php", {
            method: "POST",
            body: JSON.stringify({login: loginValue, password}),
        });

        setUser(response.user);
        return response.user;
    };

    const logout = async () => {
        await apiRequest("auth/logout.php", {
            method: "POST",
            body: JSON.stringify({}),
        });

        setUser(null);
    };

    return (
        <AuthContext.Provider value={{user, loading, login, logout, refreshUser}}>
            {children}
        </AuthContext.Provider>
    );
};

const useAuth = () => useContext(AuthContext);

export {AuthProvider, useAuth};
